var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJwt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 100,
    viewBox: "0 0 72 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 13,
    fill: "#F3F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0436 95.454C18.0436 97.686 19.3756 99.216 21.6976 99.216C23.8756 99.216 25.3876 97.812 25.3876 95.472V86.112H24.0916V95.436C24.0916 96.966 23.3356 97.992 21.6976 97.992C20.1316 97.992 19.3036 96.984 19.3036 95.454V94.95H18.0436V95.454ZM30.9634 99H32.2054L35.6614 88.056L39.1174 99H40.3414L44.2114 86.112H42.8974L40.2334 94.986C40.0894 95.472 39.9274 96.102 39.7294 97.092C39.5314 96.264 39.3514 95.616 39.1534 94.968L36.3454 86.112H34.9954L32.1874 94.968C31.9894 95.598 31.8094 96.156 31.5934 97.092C31.4314 96.246 31.2694 95.598 31.0894 94.968L28.4794 86.112H27.1294L30.9634 99ZM44.8644 87.3H48.8244V99H50.1204V87.3H54.0984V86.112H44.8644V87.3Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0885 26.565L39.0475 15.5996H32.9092L32.9501 26.565L36.0192 30.7637L39.0885 26.565ZM32.9501 45.3569V56.3631H39.0885V45.3569L36.0192 41.1583L32.9501 45.3569Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0899 45.3562L45.5558 54.2426L50.5074 50.6554L44.0415 41.7691L39.0899 40.1792V45.3562ZM32.9516 26.5642L26.4448 17.6777L21.4932 21.265L27.959 30.1514L32.9516 31.7412V26.5642Z",
    fill: "#4562FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9583 30.151L17.482 26.7676L15.5996 32.5559L26.0758 35.9801L31.0274 34.3496L27.9583 30.151ZM40.9718 37.5699L44.0409 41.7686L54.5172 45.1519L56.3996 39.3635L45.9234 35.9801L40.9718 37.5699Z",
    fill: "#2342E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9234 35.9801L56.3996 32.5559L54.5172 26.7676L44.0409 30.151L40.9718 34.3496L45.9234 35.9801ZM26.0758 35.9801L15.5996 39.3635L17.482 45.1519L27.9583 41.7686L31.0274 37.5699L26.0758 35.9801Z",
    fill: "#D0D7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.959 41.7691L21.4932 50.6554L26.4448 54.2426L32.9516 45.3562V40.1792L27.959 41.7691ZM44.0415 30.1514L50.5074 21.265L45.5558 17.6777L39.0899 26.5642V31.7412L44.0415 30.1514Z",
    fill: "#7288FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwt);
export default __webpack_public_path__ + "static/media/JWT.18672854c1203b8b52367fff373e179f.svg";
export { ForwardRef as ReactComponent };